export const BANK_DETAILS_DATA = "BANK_DETAILS_DATA";
export const BANK_DETAILS_START_LOADER = "BANK_DETAILS_START_LOADER";
export const BANK_DETAILS_STOP_LOADER = "BANK_DETAILS_STOP_LOADER";
export const BANK_DETAILS_HIDE_ERROR = "BANK_DETAILS_HIDE_ERROR";
export const BANK_DETAILS_ERROR = "BANK_DETAILS_ERROR";
